function svInitReveal() {
  var items = document.querySelectorAll('.sv-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('sv-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sv-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  items.forEach(function (el, i) {
    el.style.setProperty('--sv-delay', (i % 6) * 80 + 'ms');
    observer.observe(el);
  });
}

function svInitCountUp() {
  var items = document.querySelectorAll('.sv-count');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.dataset.target || '0');
        var duration = 1200;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = target % 1 === 0 ? Math.round(value) : value.toFixed(1);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target % 1 === 0 ? target : target.toFixed(1);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.6 }
  );
  items.forEach(function (el) { observer.observe(el); });
}

function svInitGallery() {
  document.querySelectorAll('[data-sv-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-sv-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-sv-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.dataset.svGalleryThumb;
        if (!full) return;
        main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('sv-active'); });
        thumb.classList.add('sv-active');
      });
    });
  });
}

function svInitVariants() {
  document.querySelectorAll('[data-sv-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-sv-variants-json]');
    var idInput = root.querySelector('[data-sv-variant-id]');
    var priceEl = root.querySelector('[data-sv-price]');
    var compareEl = root.querySelector('[data-sv-compare-price]');
    var submitBtn = root.querySelector('[data-sv-submit]');
    if (!dataEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = root.querySelectorAll('[data-sv-option]');
    function currentSelection() {
      var sel = [];
      selects.forEach(function (s) { sel.push(s.value); });
      return sel;
    }
    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }
    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price_formatted) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? submitBtn.dataset.svLabelAvailable : submitBtn.dataset.svLabelSoldOut;
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', updateUI); });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  svInitReveal();
  svInitCountUp();
  svInitGallery();
  svInitVariants();
});
